import { enableMapSet } from 'immer';
import PageContainer from 'page/container';
import { IS_DEVELOPMENT } from '~/modules/config';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { registerLoadEvent } from '~/modules/services/metricsService';
import { initDataCloudSdk } from '~/modules/analytics/datacloudSdk';
import { contentStore } from '~/modules/stores/contentStore';
import { i18nStore } from '~/modules/stores/i18nStore';
import { siteConfigStore } from '~/modules/stores/siteConfigStore';
import { wordPressStore } from '~/modules/stores/wordpress_store';
import { SUPPORTED_LANGUAGES } from '~/modules/utilities/language_utils';
import { listingStore } from './modules/stores/listingStore';
import { handleException } from '~/modules/utilities/error_utilities';

// Configure immer to support maps in stores
enableMapSet();

/* Map toJSON implementation to see maps in REDUX_DEV_TOOLS */
if (IS_DEVELOPMENT) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (Map.prototype as any).toJSON = function () {
        return JSON.parse(JSON.stringify([...this]));
    };
}

// Initialize i18n
const language = getUserLanguage();
if (i18nStore.getState().currentLanguage !== language && SUPPORTED_LANGUAGES.includes(language)) {
    i18nStore.setLanguage(language);
}

// Hydrate shared stores
if (window.stores?.LISTING) {
    const { listing, listingId } = window.stores.LISTING;
    if (listing && listingId) {
        listingStore.upsertListing(listingId, listing);
    }
}

if (window.stores?.WORDPRESS) {
    wordPressStore.setState(window.stores.WORDPRESS);
}

if (window.stores?.HOME_CONTENT) {
    contentStore.setHomeContent(window.stores.HOME_CONTENT);
}

if (window.stores?.SITE_CONFIG) {
    siteConfigStore.initialize(window.stores.SITE_CONFIG);
}

if (!customElements.get('page-container')) {
    customElements.define('page-container', PageContainer.CustomElementConstructor);
}

registerLoadEvent();

// Defensive wrapper: initDataCloudSdk() has no synchronous throw paths today, but future changes
// to store initialization or feature-flag access could introduce them. Keeping SDK init in its own
// catch prevents a hypothetical throw from aborting page mount and being misattributed to
// 'bootClient.bootstrap'.
try {
    initDataCloudSdk();
} catch (error) {
    handleException(error, 'bootClient.initDataCloudSdk');
}
try {
    // eslint-disable-next-line @lwc/lwc/no-document-query
    const appRoot = document.querySelector('#app-root');
    if (!appRoot) {
        throw new Error("Failed to find element with id 'app-root'");
    }
    appRoot.appendChild(document.createElement('page-container'));
} catch (error) {
    handleException(error, 'bootClient.bootstrap');
}
